import React from 'react';

import RedInfoIcon from 'icons/info-red.svg';
import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';

import DestroyModal from 'components/application/DestroyModal';

import { useCurrentActor } from 'components/contexts/CurrentActor';

export default function DestroyProjectModal({
  isDestroyProjectDisabled = false,
  onClose,
  onDestroyProjectSubmit,
  project,
}) {
  const {
    division: {
      attributes: { singularRAMSName },
    },
  } = useCurrentActor();

  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  return (
    <DestroyModal
      additionalContent={
        <div className='tw-m-0 tw-mt-5 tw-flex tw-items-center tw-gap-3 tw-rounded-lg tw-border-0 tw-bg-red-025 tw-p-3 tw-text-red-800'>
          <RedInfoIcon
            className='[&_path]:tw-fill-red-800'
            height='16px'
            width='16px'
          />
          <p className='tw-m-0'>
            <Trans
              i18nKey='projectsDashboard.components.DestroyProjectModal.additionalContent'
              ns='components'
            />
          </p>
        </div>
      }
      confirmationText={i18nTShared('deleteName', {
        interpolation: { escapeValue: false },
        name: singularRAMSName,
      })}
      displayText={i18nTShared('deleteName', {
        interpolation: { escapeValue: false },
        name: project.attributes.name,
      })}
      isDestroyDisabled={isDestroyProjectDisabled}
      isOpen={true}
      onClose={onClose}
      onDestroy={() => onDestroyProjectSubmit({ id: project.id })}
    />
  );
}

DestroyProjectModal.propTypes = {
  isDestroyProjectDisabled: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onDestroyProjectSubmit: PropTypes.func.isRequired,
  project: PropTypes.object.isRequired,
};
